import PtToast from '@patsnap-biz/toast';

import { isCaseTimeAxiosError } from './utils/errors'

import { CaseTimeImpl } from './CaseTimeImpl'

export function handleGlobalError(vm: Vue, e: Error) {
    if (!isCaseTimeAxiosError(e)) {
        return false
    }
    const i18n = vm.$i18n || e.i18n
    const error_code = e.detail?.response?.data?.error_code
    let message = ''
    const messages = i18n.getLocaleMessage('cn')
    // replace i18n.te??
    if (messages[error_code]) {
        message = i18n.t(error_code) as string
    } else {
        // 暂时吞掉非业务错误
        return true
        // const error_message = e.detail?.response?.data?.error_message
        // message = error_message || String(e.detail) || 'Error'
    }
    PtToast({
        message,
        type: 'error',
        showClose: true,
    })
    return true
}

// 内部调用时候截取
export function mayHandleError(vm: Vue, e: Error) {
    if (handleGlobalError(vm, e)) {
        return
    }
    throw e
}

export function errorCaptured(err: Error, vm: CaseTimeImpl, info: string) {
    if (handleGlobalError(vm, err)) {
        if (vm.context.config.debug) {
            // 如果不debug让vue输出详细信息
            return
        }
        //! 已经处理了
        //! vue需要返回为false, 阻止向上冒泡
        return false
    }
}
